import React from "react";
import "./Eintragungsgegenstand.css";

const Loeschungen = ({ entry }) => {
    // Filtere Löschungen aus registereintraege
    const loeschungen = entry?.registereintraege?.filter(eintrag => eintrag.type === 'Loeschung') || [];

    // Hilfsfunktion zur Formatierung des Datums
    const formatDatum = (isoString) => {
        if (!isoString) return "-";
        const date = new Date(isoString);
        return date.toLocaleString("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    // Hilfsfunktion zur Formatierung des Betrags
    const formatBetrag = (betrag, waehrung) => {
        if (betrag === null || betrag === undefined) return "-";
        return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: waehrung || "EUR"
        }).format(betrag);
    };

    return (
        <div className="common-section">
            {loeschungen.length === 0 ? (
                <p className="no-data">Keine Löschungen vorhanden</p>
            ) : (
                <table className="common-table">
                    <thead>
                        <tr>
                            <th>Nr.</th>
                            <th>Gelöschter Eintrag</th>
                            <th>Betrag</th>
                            <th>Eintragung</th>
                            <th>Bemerkungen</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loeschungen.map((item, idx) => (
                            <tr key={idx} className={`common-row${idx % 2 === 0 ? ' zebra' : ''}`}>
                                <td>{item.laufendeNr}</td>
                                <td>{item.spaltenNr || item.spalte_nr || '-'}</td>
                                <td>{formatBetrag(item.betrag)}</td>
                                <td>{formatDatum(item.zeitpunktEintragung)}</td>
                                <td>{item.sonstigeBemerkungen || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Loeschungen;
